import { ActionsUnion, createAction } from "../definitions";
import { ScheduleStatusActionTypes } from "./types";

export interface IScheduleStatusPayload {
    userId: string;
    isInitialized: boolean;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ScheduleStatusActions = {
    setScheduleStatus: (payload: IScheduleStatusPayload) => createAction(ScheduleStatusActionTypes.SET_SCHEDULESTATUS, payload),
    /**
     * Used to clear Schedule Status from storage
     * @param keepUsers Optional array of {@link IUser}s for which Schedule Status should be kept.
     */
    clearScheduleStatus: (keepUsers?: IUser[]) => createAction(ScheduleStatusActionTypes.CLEAR_SCHEDULESTATUS, keepUsers)
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ScheduleStatusActions = ActionsUnion<typeof ScheduleStatusActions>;